import "popper.js"
import React from "react"
import SideBar from "../common/layout/sidebar.component"
import OrderTabs from "../common/layout/tabs/orders.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing"
import ItemReportPopover from "./ItemReportPopover"

const ItemReportListing = () => {
    
    SideBar.activateMenu("order")

    return (
        <>
            <OrderTabs />
            <ItemReportPopover className="d-flex justify-content-end mb-2"/>
            <GenericListing 
                objectType={ObjectType.ITEM_REPORT}
            />
        </>
    )
}
export default ItemReportListing


// WEBPACK FOOTER //
// ./src/order/ItemReportListing.tsx